import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { toast } from "react-toastify";
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import ConstantInput from "components/sales/Input/constantInput/constantInput";

const DeleteMrfTypePopup = ({
  showDeleteMrfTypePopup,
  onClosePopup = () => {},
  selectedMrfTypeId,
  onDeleted = () => {},
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [remarks, setRemarks] = useState("");

  const handleConfirmDelete = async () => {
    if (!selectedMrfTypeId) return;

    setIsLoading(true);

    try {

        const res = await axios.delete(
            Config.materialRequistionForm.deleteMrfType,
            {
                params: {
                id: selectedMrfTypeId,
                remarks: remarks || null,
                },
            }
        );

      if (res?.data?.status === 0) {
        toast.success(res.data.data || "MRF Type deleted successfully!");
        onDeleted();
        onClosePopup();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        onClosePopup();
        toast.error(res?.data?.message || "Failed to delete MRF Type");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong while deleting MRF Type");
    } finally {
      setRemarks("");
      setIsLoading(false);
    }
  };

  return (
    <ModalPop
      title="Confirm Deletion"
      show={showDeleteMrfTypePopup}
      handleModalHide={onClosePopup}
      keyboard
      backdrop
    >
      <div className="text-center">
        <h4>Are you sure you want to delete this MRF Type?</h4>

        <div className="col-md-6 mt-4">
            <ConstantInput
                label="Remarks"
                name="remarks"
                type="text"
                value={remarks}
                handleChange={(value) =>
                    setRemarks(value)
                }
            />
        </div>

        <div className="d-flex justify-content-center mt-4">
          <Button
            variant="success"
            className="mx-2"
            onClick={handleConfirmDelete}
            disabled={isLoading}
          >
            {isLoading ? "Deleting..." : "Yes"}
          </Button>

          <Button
            variant="danger"
            className="mx-2"
            onClick={onClosePopup}
            disabled={isLoading}
          >
            No
          </Button>
        </div>
      </div>
    </ModalPop>
  );
};

export default DeleteMrfTypePopup;
